export type { InputProps } from "./Input";
export { InputAutocomplete } from "./InputAutocomplete"
export { ErrorMessage } from "./Input"
import Input from "./Input";

export default Input;
